import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import {
  AppBar,
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  Hidden,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Modal,
  Paper,
  Select,
  Tab,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { DataGrid } from "@mui/x-data-grid";
import PropTypes from "prop-types";
import { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import FileSaver from "file-saver";

// import ReactExport from "react-data-export";
import SwipeableViews from "react-swipeable-views";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as PlayerList } from "react-window";
import { AppDataContext } from "../../common/appContext";
import { BallotDashboardService } from "../../services/ballotDashboard.Service";
import "./AdminBallotDashboard.css";
import { exportDataToExcel } from "../../sharedComponents/CustomExportToExcel";
import Helper from "../../common/Helper";
import APIURLConstants from "../../common/ApiURLConstants";
import ExportToExcelButton from "../../sharedComponents/Button/ExportToExcelButton";
import moment from "moment";

let playerGridData = [],
  votedPlayerData = [],
  teamGridData = [];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
    margin: "15px 15px 0px 15px",
    border: "1px solid lightgrey",
    boxShadow: "2px 2px 11px grey inset",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  gridContainer: {
    margin: "15px 15px 15px 0px",
    border: "1px solid lightgrey",
    borderRadius: "none",
    height: "calc(100vh - 160px)",
    [theme.breakpoints.down("lg")]: {
      height: "auto",
      margin: theme.spacing(0, 2, 2),
    },
  },
  gridTitle: {
    color: "#1d428a",
  },
  title: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: "8px",
    },
  },
  topToolBar: {
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-end",
      display: "flex",
      justifyContent: "space-between",
      minHeight: "unset !important",
      paddingBottom: "8px",
    },
  },
  filterContainer: {
    [theme.breakpoints.down("md")]: {
      display: "flex",
      alignItems: "center",
      width: "unset !important",
      marginBottom: "5px",
    },
  },
  excelBox: {
    [theme.breakpoints.down("sm")]: {
      "& span": {
        display: "none",
      },
    },
  },
  buttonArea: {
    "& button + button": {
      marginLeft: theme.spacing(2),
    },
  },
  searchContainer: {
    height: "calc(100vh - 158px)",
    margin: "15px 15px 15px 15px",
    [theme.breakpoints.down("lg")]: {
      height: "auto",
    },
  },
  listItemRoot: { paddingLeft: "5px", height: "40px" },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  swipeView: {
    [theme.breakpoints.down("sm")]: {
      flexGrow: 1,
      "& .react-swipeable-view-container > div > div > div": {
        width: "100%",
        overflow: "auto",
      },
    },
  },
  exportToExcel: {
    backgroundColor: "white",
    minWidth: "50px",
    "&:hover": {
      backgroundColor: "white",
    },
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  gridRoot: {
    "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
      {
        outline: "none",
      },
    "& .MuiDataGrid-columnHeaders": {
      "& .MuiDataGrid-columnHeadersInner": {
        transform: "none !important",
        "& div": {
          "& .MuiDataGrid-columnHeader:first-child": {
            zIndex: 999,
          },
        },
      },
    },
    "& .MuiDataGrid-cell:first-child": {
      position: "sticky",
      top: "0",
      left: "0",
      zIndex: 999,
      [theme.breakpoints.down("sm")]: {
        backgroundColor: "white",
      },
    },
    "& .MuiDataGrid-columnHeader:first-child": {
      position: "sticky",
      top: "0",
      left: "0",
      border: "none",
      [theme.breakpoints.down("sm")]: {
        backgroundColor: "white",
      },
    },
  },
  GridIcon: {
    fontSize: "clamp(1rem, 2vw, 1.5rem) !important",
  },
}));
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function AdminBallotDashboard() {
  const theme = useTheme();
  const votedPlayers = useRef(false);
  const tab1Ref = useRef();
  const tab2Ref = useRef();
  const tab3Ref = useRef();
  const nonVotedPlayers = useRef(false);
  const classes = useStyles();
  const [playerNameSearchText, setPlayerNameSearchText] = useState("");
  const [playerData, setPlayerData] = useState([]);
  const [teamData, setTeamData] = useState([]);
  const [votedData, setVotedData] = useState([]);
  const [isVoted, setVotedPlayers] = useState(false);
  const [isNonVoted, setNonVotedPlayers] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [excelClick, setExcelClick] = useState(false);
  const [votedPlayerGridDetails, setVotedPlayerGridDetails] = useState([]);
  const [votedTeamPlayerGridDetails, setVotedTeamPlayerGridDetails] = useState(
    []
  );
  const [playerName, setPlayerName] = useState("");
  const [playerEventId, setPlayerEventId] = useState("");
  const [teamName, setTeamName] = useState("");
  const [voteSort, setVoteSort] = useState(0);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [windowInnerWidth, setWindowInnerWidth] = useState(
    window.innerWidth <= 1367 ? 1460 : "auto"
  );
  const [columnFlex, setColumnFlex] = useState(
    window.innerWidth >= 1024 ? 1 : "none"
  );
  const [columnMaxWidth, setColumnMaxWidth] = useState([
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
  ]);
  const [openModal, setOpenModal] = useState(false);
  const [openTeamModal, setTeamOpenModal] = useState(false);
  const { combineYear, user } = useContext(AppDataContext);
  const [eventId, setEventId] = useState(null);
  const [yearId, setyearId] = useState(null);
  const [customYear, setCustomyear] = useState(null);
  const [yeardata, setYear] = useState([]);
  const [eventIdval, setEventIdval] = useState("09");
  const [isWebView, setIsWebView] = useState(false);

  // Green Room Ballot & Top Five Player Vote EventId's.
  const [customEvents, setCustomEvents] = useState([]);

  //...
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const eventDropdownData = [
    {
      eventIdval: "09", //eventId: parseInt(combineYear + "09"),
      eventName: "NBA Draft Combine",
    },
    {
      eventIdval: "03", //parseInt(combineYear + "03"),
      eventName: "Green Room Ballot",
    },
    {
      eventIdval: "05", //parseInt(combineYear + "03"),
      eventName: "GLeague Ballot",
    },
    // {
    //   eventId: 202211,
    //   eventName: "Basketball Africa League",
    // },
  ];

  const style = {
    position: "absolute",
    top: "52%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "65vw",
    height: "80vh",
    bgcolor: "background.paper",
    borderRadius: "6px",
    p: 2,
    [theme.breakpoints.between("xs", "sm")]: {
      width: "76vw",
    },
  };

  useEffect(() => {
    //.. Fetching and setting the years data
    BallotDashboardService.getCombineYears().then((response) => {
      setYear(response.data.map((item) => item.eventYear));
    });

    //.. Detecting WebView
    setIsWebView(Helper.detectWebView());

    //.. Resize event listener
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    if (!combineYear) return;

    let newEventId = combineYear + "09";
    let newCombineYear = combineYear;

    if (isWebView) {
      const eventId = sessionStorage.getItem("eventId");
      if (eventId) {
        const combineYearFromStorage = eventId.slice(0, 4);
        newEventId = combineYearFromStorage + "09";
        newCombineYear = combineYearFromStorage;
      }
    }

    setEventId(newEventId);
    setyearId(newCombineYear);
    setCustomyear(newCombineYear);
  }, [combineYear, isWebView]);

  useEffect(() => {
    if (customYear) {
      setCustomEvents([`${customYear}03`, `${customYear}05`].map(Number) || []);
    }
  }, [customYear]);

  useEffect(() => {
    if (eventId) {
      getAdminViewGridData(eventId);
    }
  }, [eventId, user]);

  useEffect(() => {
    if (selectedTab === 0) {
      tab1Ref.current.addEventListener("touchstart", isolateTouch, {
        passive: true,
      });
      tab1Ref.current.addEventListener("touchmove", isolateTouch, {
        passive: true,
      });
      tab1Ref.current.addEventListener("touchend", isolateTouch, {
        passive: true,
      });
    } else if (selectedTab === 1) {
      tab2Ref.current.addEventListener("touchstart", isolateTouch, {
        passive: true,
      });
      tab2Ref.current.addEventListener("touchmove", isolateTouch, {
        passive: true,
      });
      tab2Ref.current.addEventListener("touchend", isolateTouch, {
        passive: true,
      });
    } else if (selectedTab === 2) {
      tab3Ref.current.addEventListener("touchstart", isolateTouch, {
        passive: true,
      });
      tab3Ref.current.addEventListener("touchmove", isolateTouch, {
        passive: true,
      });
      tab3Ref.current.addEventListener("touchend", isolateTouch, {
        passive: true,
      });
    }
    return () => {
      if (tab3Ref.current) {
        tab3Ref.current.removeEventListener("touchstart", isolateTouch, {
          passive: true,
        });
        tab3Ref.current.removeEventListener("touchmove", isolateTouch, {
          passive: true,
        });
        tab3Ref.current.removeEventListener("touchend", isolateTouch, {
          passive: true,
        });
      }
      if (tab2Ref.current) {
        tab2Ref.current.removeEventListener("touchstart", isolateTouch, {
          passive: true,
        });
        tab2Ref.current.removeEventListener("touchmove", isolateTouch, {
          passive: true,
        });
        tab2Ref.current.removeEventListener("touchend", isolateTouch, {
          passive: true,
        });
      }
      if (tab1Ref.current) {
        tab1Ref.current.removeEventListener("touchstart", isolateTouch, {
          passive: true,
        });
        tab1Ref.current.removeEventListener("touchmove", isolateTouch, {
          passive: true,
        });
        tab1Ref.current.removeEventListener("touchend", isolateTouch, {
          passive: true,
        });
      }
    };
  }, [selectedTab]);

  const isolateTouch = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (excelClick) {
      document.getElementById("players-list-excel-export").click();
      setExcelClick(false);
    }
  }, [excelClick]);

  const getAdminViewGridData = (eventId) => {
    if (eventId && user.loginID) {
      playerGridData = [];
      teamGridData = [];
      votedPlayerData = [];
      setLoading(true);
      resetSearchFilters();
      BallotDashboardService.getAdminViewBallotVoteDetails(eventId).then(
        (response) => {
          playerGridData = [...response.data];

          setPlayerData(playerGridData);
          setLoading(false);
        }
      );
      setLoading(true);
      BallotDashboardService.getTeamWiseAdminViewBallotVoteDetails(
        eventId
      ).then((response) => {
        teamGridData = [...response.data];

        setTeamData(teamGridData);
        setLoading(false);
      });
      setLoading(true);
      BallotDashboardService.getTeamPlayerVotedData(eventId).then(
        (response) => {
          votedPlayerData = [...response.data];
          let position = 0;
          const uniqueTeamNames = [
            ...new Set(votedPlayerData.map((item) => item.teamName)),
          ];
          uniqueTeamNames.forEach((teamName) => {
            votedPlayerData.forEach((elem) => {
              if (teamName === elem.teamName) {
                if (position === 0) {
                  elem.teamNameUI = elem.teamName;
                  position += 1;
                } else {
                  elem.teamNameUI = "";
                  position += 1;
                }
              } else {
                position = 0;
              }
            });
          });
          setVotedData(votedPlayerData);
          setLoading(false);
        }
      );
    }
  };

  const handleTabChange = (e, newValue) => {
    setSelectedTab(newValue);
    applyFilterOnTabChange(newValue);
  };

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  const handleEventChange = (eventIdval) => {
    setEventIdval(eventIdval);
    setEventId(parseInt(yearId + "" + eventIdval));
    getAdminViewGridData(parseInt(yearId + "" + eventIdval));
    setWindowInnerWidth(
      window.innerWidth <= 1367
        ? customEvents.includes(parseInt(yearId + "" + eventIdval))
          ? "auto"
          : 1460
        : "auto"
    );
  };

  const handleEventChangeYear = (yearIdVal) => {
    setyearId(yearIdVal);
    setCustomyear(yearIdVal);
    setEventId(parseInt(yearIdVal + "" + eventIdval));
    getAdminViewGridData(parseInt(yearIdVal + "" + eventIdval));
    setWindowInnerWidth(
      window.innerWidth <= 1367
        ? customEvents.includes(parseInt(yearIdVal + "" + eventIdval))
          ? "auto"
          : 1460
        : "auto"
    );
  };

  const handleClickOnTotalVotes = (playerID, playerName, EventId) => {
    setOpenModal(true);
    setModalLoading(true);
    BallotDashboardService.getBallotVotedTeamDetailsForPlayer(
      playerID,
      EventId
    ).then((response) => {
      let data = [];
      response.data.forEach((elem, i) => {
        data.push({
          id: i,
          playerName: elem.playerName,
          teamName: elem.teamName,
          votedBy: elem.modifiedByName,
          votedDate: elem.modifiedDate,
        });
      });
      setPlayerName(playerName);
      setPlayerEventId(EventId);
      setVotedPlayerGridDetails(data);
      setModalLoading(false);
      findVirtualScroller();
    });
  };

  const handleClickOnTeamTotalVotes = (teamID, TeamName, EventId) => {
    setTeamOpenModal(true);
    setModalLoading(true);
    BallotDashboardService.getBallotVotedPlayerDetailsByTeam(
      teamID,
      EventId
    ).then((response) => {
      let data = [];
      response.data.forEach((elem, i) => {
        data.push({
          id: i,
          playerName: elem.playerName,
          collegeOrClub: elem.collegeOrClub,
          shootingGuard: elem.shootingGuard,
          pointGuard: elem.pointGuard,
          smallForward: elem.smallForward,
          powerForward: elem.powerForward,
          center: elem.center,
        });
      });
      setTeamName(TeamName);
      setVotedTeamPlayerGridDetails(data);
      setModalLoading(false);
      findVirtualScroller();
    });
  };

  const handleModalClose = () => {
    setOpenModal(false);
    setPlayerName("");
    setPlayerEventId("");
    setVotedPlayerGridDetails([]);
  };

  const handleModalCloseTeam = () => {
    setTeamOpenModal(false);
    setTeamName("");
    setVotedTeamPlayerGridDetails([]);
  };

  const searchPlayerOrCollegeName = (searchValue) => {
    setPlayerNameSearchText(searchValue);
    let updatedPlayerData, tempData;
    if (selectedTab === 0) {
      tempData = [...playerGridData];
      if (searchValue) {
        updatedPlayerData = tempData.filter((elem) => {
          return (
            (elem.playerName &&
              elem.playerName
                .toLowerCase()
                .includes(searchValue.toLowerCase().trim())) ||
            (elem.collegeOrClub &&
              elem.collegeOrClub
                .toLowerCase()
                .includes(searchValue.toLowerCase().trim()))
          );
        });
        if (votedPlayers.current && nonVotedPlayers.current) {
          updatedPlayerData = updatedPlayerData.filter((elem) => {
            return elem.totalVotes > 0 || elem.totalVotes === 0;
          });
        } else if (votedPlayers.current) {
          updatedPlayerData = updatedPlayerData.filter((elem) => {
            return elem.totalVotes > 0;
          });
        } else if (nonVotedPlayers.current) {
          updatedPlayerData = updatedPlayerData.filter((elem) => {
            return elem.totalVotes === 0;
          });
        }
        setPlayerData(updatedPlayerData);
      } else {
        if (votedPlayers.current && nonVotedPlayers.current) {
          tempData = tempData.filter((elem) => {
            return elem.totalVotes > 0 || elem.totalVotes === 0;
          });
        } else if (votedPlayers.current) {
          tempData = tempData.filter((elem) => {
            return elem.totalVotes > 0;
          });
        } else if (nonVotedPlayers.current) {
          tempData = tempData.filter((elem) => {
            return elem.totalVotes === 0;
          });
        }
        setPlayerData(tempData);
      }
    } else if (selectedTab === 1) {
      tempData = [...teamGridData];
      if (searchValue) {
        updatedPlayerData = tempData.filter((elem) => {
          return (
            elem.teamName &&
            elem.teamName
              .toLowerCase()
              .includes(searchValue.toLowerCase().trim())
          );
        });
        if (votedPlayers.current && nonVotedPlayers.current) {
          updatedPlayerData = updatedPlayerData.filter((elem) => {
            return elem.totalVotes > 0 || elem.totalVotes === 0;
          });
        } else if (votedPlayers.current) {
          updatedPlayerData = updatedPlayerData.filter((elem) => {
            return elem.totalVotes > 0;
          });
        } else if (nonVotedPlayers.current) {
          updatedPlayerData = updatedPlayerData.filter((elem) => {
            return elem.totalVotes === 0;
          });
        }
        setTeamData(updatedPlayerData);
      } else {
        if (votedPlayers.current && nonVotedPlayers.current) {
          tempData = tempData.filter((elem) => {
            return elem.totalVotes > 0 || elem.totalVotes === 0;
          });
        } else if (votedPlayers.current) {
          tempData = tempData.filter((elem) => {
            return elem.totalVotes > 0;
          });
        } else if (nonVotedPlayers.current) {
          tempData = tempData.filter((elem) => {
            return elem.totalVotes === 0;
          });
        }
        setTeamData(tempData);
      }
    } else if (selectedTab === 2) {
      tempData = [...votedPlayerData];
      if (searchValue) {
        updatedPlayerData = tempData.filter((elem) => {
          return (
            elem.teamName &&
            elem.teamName
              .toLowerCase()
              .includes(searchValue.toLowerCase().trim())
          );
        });
        setVotedData(updatedPlayerData);
      } else {
        setVotedData(tempData);
      }
    }
  };

  const filterPlayers = (value, filterType) => {
    let gridData = selectedTab === 0 ? [...playerGridData] : [...teamGridData];
    const searchText = playerNameSearchText
      ? playerNameSearchText.toLowerCase().trim()
      : "";

    //...@ Filter condition based on vote status
    if (filterType === "votedPlayers") {
      votedPlayers.current = value;
      setVotedPlayers(value);
      gridData = gridData.filter((elem) => {
        if (value) {
          return nonVotedPlayers.current
            ? elem.totalVotes >= 0
            : elem.totalVotes > 0;
        } else {
          return nonVotedPlayers.current ? elem.totalVotes === 0 : true;
        }
      });
    } else {
      nonVotedPlayers.current = value;
      setNonVotedPlayers(value);
      gridData = gridData.filter((elem) => {
        if (value) {
          return votedPlayers.current
            ? elem.totalVotes >= 0
            : elem.totalVotes === 0;
        } else {
          return votedPlayers.current ? elem.totalVotes > 0 : true;
        }
      });
    }

    //...@ Apply both filter conditions based on search param if exist
    gridData = applySearchFilter(searchText, gridData);

    //...@ Update respective state values.
    selectedTab === 0 ? setPlayerData(gridData) : setTeamData(gridData);
  };

  const applyFilterOnTabChange = (currentTabID) => {
    let gridData = currentTabID === 0 ? [...playerGridData] : [...teamGridData];
    const searchText = playerNameSearchText?.toLowerCase().trim() || "";

    //...@ Filter condition based on vote status
    const filterCondition = isVoted
      ? (elem) =>
          nonVotedPlayers.current ? elem.totalVotes >= 0 : elem.totalVotes > 0
      : isNonVoted
      ? (elem) =>
          votedPlayers.current ? elem.totalVotes >= 0 : elem.totalVotes === 0
      : () => true;

    //...@ Apply both filter conditions and then search param if exist
    gridData = applySearchFilter(
      searchText,
      gridData.filter(filterCondition),
      currentTabID
    );

    //...@ Update respective state values.
    currentTabID === 0 ? setPlayerData(gridData) : setTeamData(gridData);
  };

  const applySearchFilter = (searchText, data, currentTabID = selectedTab) => {
    if (!searchText) return data;

    return data.filter((elem) => {
      if (currentTabID === 0) {
        return (
          (elem.playerName &&
            elem.playerName.toLowerCase().includes(searchText)) ||
          (elem.collegeOrClub &&
            elem.collegeOrClub.toLowerCase().includes(searchText))
        );
      } else {
        return (
          elem.teamName && elem.teamName.toLowerCase().includes(searchText)
        );
      }
    });
  };

  const resetSearchFilters = () => {
    setPlayerNameSearchText("");
    setVotedPlayers(false);
    setNonVotedPlayers(false);
    nonVotedPlayers.current = false;
    votedPlayers.current = false;
  };

  const toggleVoteSort = (key, sortOrder) => {
    let data;
    if (selectedTab === 0) {
      data = [...playerData];
    } else if (selectedTab === 1) {
      data = [...teamData];
    }
    setVoteSort(sortOrder);
    data.sort((x, y) => {
      if (sortOrder) {
        // true values first
        return x[key] === y[key] ? 0 : x[key] > y[key] ? 1 : -1;
      } else {
        // false values first
        return x[key] === y[key] ? 0 : x[key] < y[key] ? 1 : -1;
      }
    });
    if (selectedTab === 0) {
      setPlayerData(data);
    } else if (selectedTab === 1) {
      setTeamData(data);
    }
  };

  const onResize = () => {
    setColumnFlex(window.innerWidth >= 1024 ? 1 : "none");
    setWindowInnerWidth(
      window.innerWidth <= 1367
        ? customEvents.includes(eventId)
          ? "auto"
          : 1460
        : "auto"
    );
    setColumnMaxWidth(
      window.innerWidth <= 600
        ? [
            "200px",
            "280px",
            "120px",
            "120px",
            "120px",
            "120px",
            "120px",
            "100px",
          ]
        : ["none", "none", "none", "none", "none", "none", "none", "none"]
    );
  };

  //... NEW EXCEL EXPORT LIBRARY
  const exportToExcelHandler = async () => {
    const sheetsData = [
      {
        sheetName: "All Players",
        tables: getAllPlayersTablesForData(),
      },
      {
        sheetName: "Team Wise Voting",
        tables: getTeamWiseVotingTablesForData(),
      },
    ];

    await exportDataToExcel(sheetsData, "Admin View Ballot Dashboard");
  };

  const exportToExcelPlayerVotedBy = async () => {
    const sheetsData = [
      {
        sheetName: `${playerName}-${playerEventId}`,
        tables: getPLayerVotedByTablesForData(),
      },
    ];
    await exportDataToExcel(
      sheetsData,
      `${playerName}-${playerEventId} Ballot View`
    );
  };

  const getAllPlayersTablesForData = () => {
    const styleHeaderCss = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: {
        wrapText: true,
        horizontal: "center",
        vertical: "top",
      },
    };

    return [
      {
        title: "",
        headerNames: [
          {
            title: "Player",
            style: styleHeaderCss,
            width: "30",
          },
          {
            title: "College / Club",
            style: styleHeaderCss,
            width: "30",
          },
          {
            title: "Total Votes",
            style: styleHeaderCss,
            width: "20",
          },
          ...(customEvents && !customEvents.includes(eventId)
            ? [
                {
                  title: "Point Guard",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Shooting Guard",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Small Forward",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Power Forward",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Center",
                  style: styleHeaderCss,
                  width: "20",
                },
              ]
            : []),
        ],
        data:
          playerGridData?.length > 0
            ? playerGridData.map((item) => {
                const data = {
                  playerName: item.playerName ? item.playerName : "",
                  collegeOrClub: item.collegeOrClub ? item.collegeOrClub : "",
                  totalVotes: item.totalVotes
                    ? item.totalVotes.toString()
                    : "0",
                };

                if (customEvents && !customEvents.includes(eventId)) {
                  data.pointGuard = item.pointGuard
                    ? item.pointGuard.toString()
                    : "0";
                  data.shootingGuard = item.shootingGuard
                    ? item.shootingGuard.toString()
                    : "0";
                  data.smallForward = item.smallForward
                    ? item.smallForward.toString()
                    : "0";
                  data.powerForward = item.powerForward
                    ? item.powerForward.toString()
                    : "0";
                  data.center = item.center ? item.center.toString() : "0";
                }

                return data;
              })
            : [],

        columnStyles: Array(8).fill({
          font: { size: 11 },
          width: 40,
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getTeamWiseVotingTablesForData = () => {
    const styleHeaderCss = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: {
        wrapText: true,
        horizontal: "center",
        vertical: "top",
      },
    };

    return [
      {
        title: "",
        headerNames: [
          {
            title: "Team",
            style: styleHeaderCss,
            width: "30",
          },
          {
            title: "Submitted Date",
            style: styleHeaderCss,
            width: "30",
          },
          ...(customEvents && !customEvents.includes(eventId)
            ? [
                {
                  title: "Total Votes",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Point Guard",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Shooting Guard",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Small Forward",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Power Forward",
                  style: styleHeaderCss,
                  width: "20",
                },
                {
                  title: "Center",
                  style: styleHeaderCss,
                  width: "20",
                },
              ]
            : []),
        ],
        data:
          teamGridData?.length > 0
            ? teamGridData.map((item) => {
                const dataObj = {
                  playerName: item.teamName ? item.teamName : "",
                  collegeOrClub: item.submittedDate
                    ? moment(item.submittedDate).format("M/D/YYYY, h:mm:ss A")
                    : "--",
                  totalVotes: item.totalVotes
                    ? item.totalVotes.toString()
                    : "0",
                };

                if (!customEvents.includes(eventId)) {
                  dataObj.pointGuard = item.pointGuard
                    ? item.pointGuard.toString()
                    : "0";
                  dataObj.shootingGuard = item.shootingGuard
                    ? item.shootingGuard.toString()
                    : "0";
                  dataObj.smallForward = item.smallForward
                    ? item.smallForward.toString()
                    : "0";
                  dataObj.powerForward = item.powerForward
                    ? item.powerForward.toString()
                    : "0";
                  dataObj.center = item.center ? item.center.toString() : "0";
                }

                return dataObj;
              })
            : [],
        columnStyles: Array(8).fill({
          font: { size: 11 },
          width: 40,
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const getPLayerVotedByTablesForData = () => {
    const styleHeaderCss = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "e6eefb" },
      },
      font: { sz: "11", bold: true, color: { rgb: "1d428a" } },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
      alignment: {
        wrapText: true,
        horizontal: "center",
        vertical: "top",
      },
    };
    return [
      {
        title: "",
        headerNames: [
          {
            title: "Player Name",
            style: styleHeaderCss,
            width: "30",
          },
          {
            title: "Team Name",
            style: styleHeaderCss,
            width: "30",
          },
          {
            title: "Voted By",
            style: styleHeaderCss,
            width: "30",
          },
          {
            title: "Voted Datetime",
            style: styleHeaderCss,
            width: "30",
          },
        ],
        data:
          votedPlayerGridDetails?.length > 0
            ? votedPlayerGridDetails.map((item) => {
                const data = {
                  playerName: item.playerName ? item.playerName : "",
                  teamName: item.teamName ? item.teamName : "",
                  votedBy: item.votedBy ? item.votedBy : "",
                  votedDate: item.votedDate ? item.votedDate : null,
                };

                return data;
              })
            : [],

        columnStyles: Array(4).fill({
          font: { size: 11 },
          width: 40,
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
          alignment: {
            horizontal: "center",
            vertical: "middle",
          },
        }),
      },
    ];
  };

  const PlayerRows = ({ index, style }) => (
    <Box
      className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
      style={style}
      sx={{
        display: "flex",
        // gridTemplateColumns: "300px 400px 200px 400px",
      }}
    >
      <Box
        sx={{
          maxWidth: `${columnMaxWidth[0]}`,
          flex: `1 0 250px`,
        }}
      >
        {/* <Tooltip
          title={playerData[index].playerName}
          placement="bottom-start"
          // enterTouchDelay={0}
        > */}
        <div>
          <Typography
            noWrap
            pl={3}
            sx={{ paddingTop: "10px", fontWeight: "500" }}
          >
            {playerData[index].playerName}
          </Typography>
        </div>
        {/* </Tooltip> */}
      </Box>
      <Box sx={{ maxWidth: `${columnMaxWidth[1]}`, flex: `1 0 280px` }}>
        <div>
          <Typography noWrap sx={{ paddingTop: "10px", fontWeight: "500" }}>
            {playerData[index].collegeOrClub}
          </Typography>
        </div>
      </Box>
      {/* {!customEvents.includes(eventId) ? ( */}

      {/* ) : (
        ""
      )} */}
      <Box
        sx={{
          maxWidth: `${columnMaxWidth[2]}`,
          flex: `1 0 120px`,
        }}
      >
        <Typography
          noWrap
          align="center"
          sx={{ paddingTop: "10px", fontWeight: "500" }}
        >
          {playerData[index].totalVotes > 0 ? (
            <span
              style={{
                color: "#1d428a",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => {
                handleClickOnTotalVotes(
                  playerData[index].playerID,
                  playerData[index].playerName,
                  eventId
                );
              }}
            >
              {playerData[index].totalVotes}
            </span>
          ) : (
            <span style={{ color: "#696969" }}>
              {playerData[index].totalVotes}
            </span>
          )}
        </Typography>
      </Box>
      {!customEvents.includes(eventId) ? (
        //customEvents.includes(eventId)
        <>
          <Box sx={{ maxWidth: `${columnMaxWidth[3]}`, flex: `1 0 100px` }}>
            <Typography
              noWrap
              align="center"
              sx={{ paddingTop: "10px", fontWeight: "500" }}
            >
              {playerData[index].pointGuard > 0 ? (
                <span
                  style={{
                    color: "#1d428a",
                  }}
                >
                  {playerData[index].pointGuard}
                </span>
              ) : (
                <span style={{ color: "#696969" }}>
                  {playerData[index].pointGuard}
                </span>
              )}
            </Typography>
          </Box>
          <Box sx={{ maxWidth: `${columnMaxWidth[4]}`, flex: `1 0 120px` }}>
            <Typography
              noWrap
              align="center"
              sx={{ paddingTop: "10px", fontWeight: "500" }}
            >
              {playerData[index].shootingGuard > 0 ? (
                <span
                  style={{
                    color: "#1d428a",
                  }}
                >
                  {playerData[index].shootingGuard}
                </span>
              ) : (
                <span style={{ color: "#696969" }}>
                  {playerData[index].shootingGuard}
                </span>
              )}
            </Typography>
          </Box>
          <Box sx={{ maxWidth: `${columnMaxWidth[5]}`, flex: `1 0 120px` }}>
            <Typography
              noWrap
              align="center"
              sx={{ paddingTop: "10px", fontWeight: "500" }}
            >
              {playerData[index].smallForward > 0 ? (
                <span
                  style={{
                    color: "#1d428a",
                  }}
                >
                  {playerData[index].smallForward}
                </span>
              ) : (
                <span style={{ color: "#696969" }}>
                  {playerData[index].smallForward}
                </span>
              )}
            </Typography>
          </Box>
          <Box sx={{ maxWidth: `${columnMaxWidth[6]}`, flex: `1 0 100px` }}>
            <Typography
              noWrap
              align="center"
              sx={{ paddingTop: "10px", fontWeight: "500" }}
            >
              {playerData[index].powerForward > 0 ? (
                <span
                  style={{
                    color: "#1d428a",
                  }}
                >
                  {playerData[index].powerForward}
                </span>
              ) : (
                <span style={{ color: "#696969" }}>
                  {playerData[index].powerForward}
                </span>
              )}
            </Typography>
          </Box>
          <Box sx={{ maxWidth: `${columnMaxWidth[7]}`, flex: `1 0 100px` }}>
            <Typography
              noWrap
              align="center"
              sx={{ paddingTop: "10px", fontWeight: "500" }}
            >
              {playerData[index].center > 0 ? (
                <span
                  style={{
                    color: "#1d428a",
                  }}
                >
                  {playerData[index].center}
                </span>
              ) : (
                <span style={{ color: "#696969" }}>
                  {playerData[index].center}
                </span>
              )}
            </Typography>
          </Box>
        </>
      ) : (
        ""
      )}
    </Box>
  );

  const TeamRows = ({ index, style }) => {
    return (
      <Box
        className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
        style={style}
        sx={{
          display: "flex",
          // gridTemplateColumns: "300px 400px 200px 400px",
        }}
      >
        <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 200px` }}>
          {/* <Tooltip
            title={teamData[index].teamName}
            placement="bottom-start"
            enterTouchDelay={0}
          > */}
          <div>
            <Typography
              noWrap
              pl={3}
              sx={{ paddingTop: "10px", fontWeight: "500" }}
              // title={teamData[index].teamName}
            >
              {teamData[index].teamName}
            </Typography>
          </div>
          {/* </Tooltip> */}
        </Box>
        <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 180px` }}>
          <Typography
            noWrap
            pl={3}
            sx={{ paddingTop: "10px", fontWeight: "500" }}
            title={teamData[index].submittedDate}
          >
            {teamData[index].submittedDate ? (
              moment(teamData[index].submittedDate).format(
                "M/D/YYYY, h:mm:ss A"
              )
            ) : (
              <label style={{ marginLeft: "30px" }}>--</label>
            )}
          </Typography>
        </Box>
        <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 120px` }}>
          <Typography
            noWrap
            align="center"
            sx={{ paddingTop: "10px", fontWeight: "500" }}
          >
            {teamData[index].totalVotes > 0 ? (
              <span
                style={{
                  color: "#1d428a",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  handleClickOnTeamTotalVotes(
                    teamData[index].teamID,
                    teamData[index].teamName,
                    eventId
                  );
                }}
              >
                {teamData[index].totalVotes}
              </span>
            ) : (
              <span style={{ color: "#696969" }}>
                {teamData[index].totalVotes}
              </span>
            )}
          </Typography>
        </Box>
        {!customEvents.includes(eventId) ? (
          //customEvents.includes(eventId)
          <>
            <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 120px` }}>
              <Typography
                noWrap
                align="center"
                sx={{ paddingTop: "10px", fontWeight: "500" }}
              >
                {teamData[index].pointGuard > 0 ? (
                  <span
                    style={{
                      color: "#1d428a",
                    }}
                  >
                    {teamData[index].pointGuard}
                  </span>
                ) : (
                  <span style={{ color: "#696969" }}>
                    {teamData[index].pointGuard}
                  </span>
                )}
              </Typography>
            </Box>
            <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 120px` }}>
              <Typography
                noWrap
                align="center"
                sx={{ paddingTop: "10px", fontWeight: "500" }}
              >
                {teamData[index].shootingGuard > 0 ? (
                  <span
                    style={{
                      color: "#1d428a",
                    }}
                  >
                    {teamData[index].shootingGuard}
                  </span>
                ) : (
                  <span style={{ color: "#696969" }}>
                    {teamData[index].shootingGuard}
                  </span>
                )}
              </Typography>
            </Box>
            <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 120px` }}>
              <Typography
                noWrap
                align="center"
                sx={{ paddingTop: "10px", fontWeight: "500" }}
              >
                {teamData[index].smallForward > 0 ? (
                  <span
                    style={{
                      color: "#1d428a",
                    }}
                  >
                    {teamData[index].smallForward}
                  </span>
                ) : (
                  <span style={{ color: "#696969" }}>
                    {teamData[index].smallForward}
                  </span>
                )}
              </Typography>
            </Box>
            <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 120px` }}>
              <Typography
                noWrap
                align="center"
                sx={{ paddingTop: "10px", fontWeight: "500" }}
              >
                {teamData[index].powerForward > 0 ? (
                  <span
                    style={{
                      color: "#1d428a",
                    }}
                  >
                    {teamData[index].powerForward}
                  </span>
                ) : (
                  <span style={{ color: "#696969" }}>
                    {teamData[index].powerForward}
                  </span>
                )}
              </Typography>
            </Box>
            <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 120px` }}>
              <Typography
                noWrap
                align="center"
                sx={{ paddingTop: "10px", fontWeight: "500" }}
              >
                {teamData[index].center > 0 ? (
                  <span
                    style={{
                      color: "#1d428a",
                    }}
                  >
                    {teamData[index].center}
                  </span>
                ) : (
                  <span style={{ color: "#696969" }}>
                    {teamData[index].center}
                  </span>
                )}
              </Typography>
            </Box>
          </>
        ) : (
          ""
        )}
      </Box>
    );
  };

  const VotedPlayerRows = ({ index, style }) => (
    <Box
      className={`${index % 2 ? "ListItemOdd" : "ListItemEven"}`}
      style={style}
      sx={{
        display: "flex",
        // gridTemplateColumns: "300px 400px 200px 400px",
      }}
    >
      <Box
        sx={{
          maxWidth: `${columnMaxWidth[0]}`,
          flex: `1 0 250px`,
        }}
      >
        <Typography
          noWrap
          pl={3}
          sx={{ paddingTop: "10px", fontWeight: "500" }}
        >
          {votedData[index].teamNameUI}
        </Typography>
      </Box>
      <Box
        sx={{
          maxWidth: `${columnMaxWidth[0]}`,
          flex: `1 0 250px`,
        }}
      >
        <Typography
          noWrap
          pl={3}
          sx={{ paddingTop: "10px", fontWeight: "500" }}
        >
          {votedData[index].playerName ? votedData[index].playerName : "--"}
        </Typography>
      </Box>
      {/* {!customEvents === eventId ? ( */}
      {/* //customEvents.includes(eventId) */}
      <Box sx={{ maxWidth: `${columnMaxWidth[1]}`, flex: `1 0 280px` }}>
        <Typography noWrap sx={{ paddingTop: "10px", fontWeight: "500" }}>
          {votedData[index].collegeOrClub}
        </Typography>
      </Box>
      {/* ) : (
        ""
      )} */}
      {!customEvents.includes(eventId) ? (
        //customEvents.includes(eventId)
        <Box sx={{ maxWidth: `${columnMaxWidth[0]}`, flex: `1 0 250px` }}>
          <Typography
            align="center"
            noWrap
            sx={{ paddingTop: "10px", fontWeight: "500" }}
          >
            {votedData[index].votePositionName
              ? votedData[index].votePositionName
              : "--"}
          </Typography>
        </Box>
      ) : (
        ""
      )}
    </Box>
  );

  async function downloadBallotVoteSubmissionReport() {
    try {
      const url = APIURLConstants.GET_BALLOT_VOTE_SUBMISSION_EXCEL_REPORT();
      const queryParams = { EventId: eventId };

      const token = sessionStorage.getItem("accessToken").replace(/\"/g, "");

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(url, {
        params: queryParams,
        responseType: "blob",
        headers: headers,
      });

      const contentDisposition = response.headers["content-disposition"];
      const fileName = contentDisposition
        ? contentDisposition.split("filename=")[1].split(";")[0]
        : "exported-file.xlsx";

      FileSaver.saveAs(response.data, fileName);
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const findVirtualScroller = () => {
    const virtualScrollerElement = document.querySelector(
      ".MuiDataGrid-virtualScroller"
    );
    if (!virtualScrollerElement) {
      setTimeout(findVirtualScroller, 100);
    } else {
      virtualScrollerElement.addEventListener("scroll", handleScrollHorizontal);
      return () => {
        virtualScrollerElement.removeEventListener(
          "scroll",
          handleScrollHorizontal
        );
      };
    }
  };

  const handleScrollHorizontal = () => {
    const currentScrollPos = document.querySelector(
      ".MuiDataGrid-virtualScroller"
    ).scrollLeft;
    const columnsHeaders = document.querySelectorAll(
      ".MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader:first-child)"
    );
    columnsHeaders.forEach((columnHeader) => {
      columnHeader.style.transform = `translate3d(-${currentScrollPos}px, 0px, 0px)`;
    });
  };

  return (
    <>
      <AppBar
        position="sticky"
        className={classes.appbarBackground}
        sx={{ zIndex: "1098" }}
      >
        <Toolbar className={classes.topToolBar}>
          <Grid container spacing={1} alignItems="center">
            {/* Title */}
            <Grid item xs={12} md={4} lg={2.5}>
              <Typography
                variant="h6"
                className={`${classes.title} header-title`}
              >
                Admin View Ballot Dashboard
              </Typography>
            </Grid>

            {/* Event Dropdown */}
            <Grid item xs={6} md={2} lg={2} className={classes.filterContainer}>
              <FormControl
                fullWidth
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    fontSize: { xs: "0.6rem", lg: "1rem" },
                  },
                }}
              >
                <InputLabel>Event</InputLabel>
                <Select
                  value={eventIdval}
                  label="Event"
                  onChange={(e) => handleEventChange(e.target.value)}
                >
                  {eventDropdownData.map((elem, i) => (
                    <MenuItem key={i} value={elem.eventIdval}>
                      {elem.eventName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Year Dropdown */}
            <Grid item xs={3} md={1} lg={1} className={classes.filterContainer}>
              <FormControl
                fullWidth
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    fontSize: { xs: "0.6rem", lg: "1rem" },
                  },
                }}
              >
                <InputLabel>Year</InputLabel>
                <Select
                  value={yearId + ""}
                  label="Year"
                  onChange={(e) => handleEventChangeYear(e.target.value)}
                  MenuProps={{ PaperProps: { style: { maxHeight: 200 } } }}
                >
                  {yeardata.map((elem, i) => (
                    <MenuItem key={i} value={elem}>
                      {elem}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Export to Excel Button */}
            <Grid
              item
              xs={3}
              md={5}
              lg={6.5}
              className={classes.filterContainer}
            >
              {!isWebView && (
                <ExportToExcelButton
                  onClick={exportToExcelHandler}
                  title="Dowbload Ballot Report"
                  imageSrc="../../../../playerProfile/excel.png"
                />
              )}
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box>
        <Grid container>
          <Grid item lg={2} md={12} sm={12} xs={12}>
            <Paper className={classes.searchContainer} elevation={8} square>
              <Typography className="input-title">Search</Typography>
              <FormControl fullWidth>
                <TextField
                  size="small"
                  className="search-box"
                  label={
                    selectedTab
                      ? "Search Team Name"
                      : !customEvents.includes(eventId)
                      ? //customEvents.includes(eventId)
                        "Search Player or College Name"
                      : "Search Player Name"
                  }
                  value={playerNameSearchText || ""}
                  onChange={(e) => searchPlayerOrCollegeName(e.target.value)}
                />
              </FormControl>
              {selectedTab !== 2 && (
                <>
                  <Typography className="input-title">Filters</Typography>
                  <Box>
                    <List dense disablePadding>
                      <ListItem
                        classes={{ root: classes.listItemRoot }}
                        disablePadding
                      >
                        <ListItemIcon>
                          <Checkbox
                            color="success"
                            checked={isVoted}
                            onChange={(e) =>
                              filterPlayers(e.target.checked, "votedPlayers")
                            }
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary="Voted Players"
                          primaryTypographyProps={{ variant: "subtitle2" }}
                        />
                      </ListItem>
                      <ListItem
                        classes={{ root: classes.listItemRoot }}
                        disablePadding
                      >
                        <ListItemIcon>
                          <Checkbox
                            color="success"
                            checked={isNonVoted}
                            onChange={(e) =>
                              filterPlayers(e.target.checked, "nonVotedPlayers")
                            }
                            inputProps={{ "aria-label": "controlled" }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary="Non-Voted Players"
                          primaryTypographyProps={{ variant: "subtitle2" }}
                        />
                      </ListItem>
                    </List>
                  </Box>
                </>
              )}
            </Paper>
          </Grid>
          <Grid item lg={10} md={12} sm={12} xs={12}>
            <Paper className={classes.gridContainer} elevation={8} square>
              <Box
                component="div"
                display="flex"
                flexGrow={1}
                flexDirection="column"
                sx={{ bgcolor: "background.paper" }}
              >
                <AppBar position="static" className={classes.appbar}>
                  <Hidden mdUp>
                    <Box
                      display="flex"
                      alignItems="center"
                      width="100%"
                      justifyContent="flex-start"
                    >
                      <Tabs
                        scrollButtons
                        allowScrollButtonsMobile
                        value={selectedTab}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="scrollable"
                        aria-label="full width tabs example"
                      >
                        <Tab
                          label="All Players"
                          sx={{ textTransform: "none" }}
                          {...a11yProps(0)}
                        />
                        <Tab
                          label="Team Wise Voting"
                          sx={{ textTransform: "none" }}
                          {...a11yProps(1)}
                        />
                        {/* <Tab
                        label="Team Players Voting"
                        sx={{ textTransform: "none" }}
                        {...a11yProps(2)}
                      /> */}
                        {/* <Tab label="Ballot Leaderboard" {...a11yProps(2)} /> */}
                      </Tabs>
                      {!isWebView && (
                        <ExportToExcelButton
                          onClick={downloadBallotVoteSubmissionReport}
                          title="Download Ballot Vote Submission Report"
                          imageSrc="../../../../playerProfile/excel.png"
                        />
                      )}
                    </Box>
                  </Hidden>
                  <Hidden mdDown>
                    <Box
                      display="flex"
                      alignItems="center"
                      width="100%"
                      justifyContent="flex-start"
                    >
                      <Tabs
                        scrollButtons
                        allowScrollButtonsMobile
                        value={selectedTab}
                        onChange={handleTabChange}
                        indicatorColor="primary"
                        textColor="inherit"
                        variant="standard"
                        aria-label="full width tabs example"
                      >
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="All Players"
                          {...a11yProps(0)}
                        />
                        <Tab
                          sx={{ textTransform: "none" }}
                          label="Team Wise Voting"
                          {...a11yProps(1)}
                        />
                        {/* <Tab
                        sx={{ textTransform: "none" }}
                        label="Team Players Voting"
                        {...a11yProps(2)}
                      /> */}
                        {/* <Tab
                        sx={{ textTransform: "none" }}
                        label="Ballot Leaderboard"
                        {...a11yProps(2)}
                      /> */}
                      </Tabs>
                      {!isWebView && (
                        <ExportToExcelButton
                          onClick={downloadBallotVoteSubmissionReport}
                          title="Download Ballot Vote Submission Report"
                          imageSrc="../../../../playerProfile/excel.png"
                        />
                      )}
                    </Box>
                  </Hidden>
                </AppBar>
                <SwipeableViews
                  className={classes.swipeView}
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={selectedTab}
                  onChangeIndex={handleChangeIndex}
                >
                  {/* Tab 1 */}
                  <TabPanel value={selectedTab} index={0} dir={theme.direction}>
                    <Box ref={tab1Ref}>
                      <Box
                        mt={1}
                        className="row-header"
                        sx={{ display: "flex", width: windowInnerWidth }}
                      >
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[0]}`,
                            flex: `1 0 250px`,
                          }}
                        >
                          <Typography
                            noWrap
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px 10px 25px",
                              fontWeight: "500",
                            }}
                          >
                            Player
                          </Typography>
                        </Box>
                        {/* {!customEvents.includes(eventId) ? (
                          //customEvents.includes(eventId) */}
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[1]}`,
                            flex: `1 0 280px`,
                          }}
                        >
                          <Typography
                            noWrap
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px",
                              fontWeight: "500",
                            }}
                          >
                            College / Club
                          </Typography>
                        </Box>
                        {/* ) : (
                          ""
                        )} */}
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[2]}`,
                            flex: `1 0 120px`,
                            display: "flex",
                            columnGap: "5px",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            noWrap
                            align="center"
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px",
                              fontWeight: "500",
                            }}
                          >
                            Total Votes
                          </Typography>
                          <Box display="flex" flexDirection="column">
                            <div title="Ascending">
                              <ArrowDropUpIcon
                                sx={{
                                  cursor: "pointer",
                                  marginBottom: "-15px",
                                }}
                                onClick={(e) => toggleVoteSort("totalVotes", 1)}
                              />
                            </div>
                            <div title="Descending">
                              <ArrowDropDownIcon
                                sx={{ cursor: "pointer" }}
                                onClick={(e) => toggleVoteSort("totalVotes", 0)}
                              />
                            </div>
                          </Box>
                        </Box>
                        {!customEvents.includes(eventId) ? (
                          //customEvents.includes(eventId)
                          <>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[3]}`,
                                flex: `1 0 100px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Point Guard
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[4]}`,
                                flex: `1 0 120px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Shooting Guard
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[5]}`,
                                flex: `1 0 120px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Small Forward
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[6]}`,
                                flex: `1 0 100px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Power Forward
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[7]}`,
                                flex: `1 0 100px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Center
                              </Typography>
                            </Box>
                          </>
                        ) : (
                          ""
                        )}
                      </Box>
                      <Box
                        sx={{
                          height: "calc(100vh - 265px)",
                          width: windowInnerWidth,
                        }}
                      >
                        <AutoSizer>
                          {({ height, width }) => (
                            <PlayerList
                              height={isSmallScreen ? height - 100 : height}
                              width={width}
                              itemSize={45}
                              itemCount={playerData.length}
                            >
                              {PlayerRows}
                            </PlayerList>
                          )}
                        </AutoSizer>
                        {loading && (
                          <Box sx={{ marginTop: "15vh", marginLeft: "50%" }}>
                            <CircularProgress />
                          </Box>
                        )}
                        {!loading && !playerData.length ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "15%",
                            }}
                          >
                            No Results
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                  {/* Tab 2 */}
                  <TabPanel value={selectedTab} index={1} dir={theme.direction}>
                    <Box ref={tab2Ref}>
                      <Box
                        mt={1}
                        className="row-header"
                        sx={{ display: "flex", width: windowInnerWidth }}
                      >
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[0]}`,
                            flex: `1 0 200px`,
                          }}
                        >
                          <Typography
                            noWrap
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px 10px 25px",
                              fontWeight: "500",
                            }}
                          >
                            Team
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[0]}`,
                            flex: `1 0 180px`,
                          }}
                        >
                          <Typography
                            noWrap
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px 10px 25px",
                              fontWeight: "500",
                            }}
                          >
                            Submitted Date
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[0]}`,
                            flex: `1 0 120px`,
                            display: "flex",
                            columnGap: "5px",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            noWrap
                            align="center"
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px",
                              fontWeight: "500",
                            }}
                          >
                            Total Votes
                          </Typography>
                          <Box display="flex" flexDirection="column">
                            <div title="Ascending">
                              <ArrowDropUpIcon
                                sx={{
                                  cursor: "pointer",
                                  marginBottom: "-15px",
                                }}
                                onClick={(e) => toggleVoteSort("totalVotes", 1)}
                              />
                            </div>
                            <div title="Descending">
                              <ArrowDropDownIcon
                                sx={{ cursor: "pointer" }}
                                onClick={(e) => toggleVoteSort("totalVotes", 0)}
                              />
                            </div>
                          </Box>
                        </Box>
                        {!customEvents.includes(eventId) ? (
                          //customEvents.includes(eventId)
                          <>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[0]}`,
                                flex: `1 0 120px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Point Guard
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[0]}`,
                                flex: `1 0 120px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Shooting Guard
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[0]}`,
                                flex: `1 0 120px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Small Forward
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[0]}`,
                                flex: `1 0 120px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Power Forward
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                maxWidth: `${columnMaxWidth[0]}`,
                                flex: `1 0 120px`,
                              }}
                            >
                              <Typography
                                noWrap
                                align="center"
                                variant="subtitle1"
                                sx={{
                                  padding: "10px 0px",
                                  fontWeight: "500",
                                }}
                              >
                                Center
                              </Typography>
                            </Box>
                          </>
                        ) : (
                          ""
                        )}
                      </Box>
                      <Box
                        sx={{
                          height: "calc(100vh - 265px)",
                          width: windowInnerWidth,
                        }}
                      >
                        <AutoSizer>
                          {({ height, width }) => (
                            <PlayerList
                              height={isSmallScreen ? height - 100 : height}
                              width={width}
                              itemSize={45}
                              itemCount={teamData.length}
                            >
                              {TeamRows}
                            </PlayerList>
                          )}
                        </AutoSizer>
                        {loading && (
                          <Box sx={{ marginTop: "15vh", marginLeft: "50%" }}>
                            <CircularProgress />
                          </Box>
                        )}
                        {!loading && !teamData.length ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "15%",
                            }}
                          >
                            No Results
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                  {/* Tab 3*/}
                  <TabPanel value={selectedTab} index={2} dir={theme.direction}>
                    <Box ref={tab3Ref}>
                      <Box
                        mt={1}
                        className="row-header"
                        sx={{ display: "flex", width: windowInnerWidth }}
                      >
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[0]}`,
                            flex: `1 0 250px`,
                          }}
                        >
                          <Typography
                            noWrap
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px 10px 25px",
                              fontWeight: "500",
                            }}
                          >
                            Team
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[0]}`,
                            flex: `1 0 250px`,
                          }}
                        >
                          <Typography
                            noWrap
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px 10px 25px",
                              fontWeight: "500",
                            }}
                          >
                            Player Name
                          </Typography>
                        </Box>
                        {/* {!customEvents.includes(eventId) ? (
                          //customEvents.includes(eventId) */}
                        <Box
                          sx={{
                            maxWidth: `${columnMaxWidth[1]}`,
                            flex: `1 0 280px`,
                          }}
                        >
                          <Typography
                            noWrap
                            variant="subtitle1"
                            sx={{
                              padding: "10px 0px",
                              fontWeight: "500",
                            }}
                          >
                            College / Club
                          </Typography>
                        </Box>
                        {/* ) : (
                          ""
                        )} */}
                        {!customEvents.includes(eventId) ? (
                          //customEvents.includes(eventId)

                          <Box
                            sx={{
                              maxWidth: `${columnMaxWidth[0]}`,
                              flex: `1 0 250px`,
                            }}
                          >
                            <Typography
                              noWrap
                              align="center"
                              variant="subtitle1"
                              sx={{
                                padding: "10px 0px 10px 25px",
                                fontWeight: "500",
                              }}
                            >
                              Position Voted
                            </Typography>
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                      <Box
                        sx={{
                          height: "calc(100vh - 265px)",
                          width: windowInnerWidth,
                        }}
                      >
                        <AutoSizer>
                          {({ height, width }) => (
                            <PlayerList
                              height={height}
                              width={width}
                              itemSize={45}
                              itemCount={votedData.length}
                            >
                              {VotedPlayerRows}
                            </PlayerList>
                          )}
                        </AutoSizer>
                        {loading && (
                          <Box sx={{ marginTop: "15vh", marginLeft: "50%" }}>
                            <CircularProgress />
                          </Box>
                        )}
                        {!loading && !votedData.length ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "15%",
                            }}
                          >
                            No Results
                          </Box>
                        ) : (
                          ""
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                  {/* <TabPanel value={selectedTab} index={2} dir={theme.direction}>
                    <div style={{ paddingTop: "20%", textAlign: "center" }}>
                      Ballot Leaderboard
                    </div>
                  </TabPanel>{" "} */}
                  <Modal
                    open={openModal}
                    onClose={handleModalClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Box display="flex">
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            color="primary"
                            className="header-title"
                          >
                            Player Name:{" "}
                            <span style={{ color: "#c8102e" }}>
                              {playerName}
                            </span>
                          </Typography>
                          {!isWebView && playerName && (
                            <ExportToExcelButton
                              onClick={exportToExcelPlayerVotedBy}
                              title="Export to excel"
                              imageSrc="../../../../playerProfile/excel.png"
                            />
                          )}
                        </Box>
                        <IconButton
                          size="small"
                          aria-label="Close"
                          onClick={handleModalClose}
                          title="Close"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                      <Box
                        sx={{
                          height: "91%",
                          marginTop: theme.spacing(0.7),
                        }}
                      >
                        <DataGrid
                          className={classes.gridRoot}
                          pageSize={votedPlayerGridDetails.length}
                          rowHeight={38}
                          headerHeight={35}
                          hideFooterPagination={true}
                          autoHeight={false}
                          rows={votedPlayerGridDetails}
                          columnBuffer={3}
                          columns={[
                            { field: "id", hide: true, flex: 1 },
                            {
                              field: "teamName",
                              headerName: "Team Name",
                              width: 180,
                              flex: columnFlex,
                              sortable: false,
                            },
                            {
                              field: "votedBy",
                              headerName: "Voted By",
                              width: 180,
                              flex: columnFlex,
                              sortable: false,
                            },
                            {
                              field: "votedDate",
                              headerName: "Voted Date",
                              width: 200,
                              flex: columnFlex,
                              sortable: false,
                            },
                          ]}
                          disableSelectionOnClick
                          disableColumnSelector
                          getCellClassName={(params) => {
                            if (params.field !== "actions") {
                              return `admin-pref-grid-cells`;
                            }
                          }}
                          components={{
                            NoRowsOverlay: () =>
                              modalLoading ? (
                                <Box
                                  sx={{ marginTop: "15vh", marginLeft: "50%" }}
                                >
                                  <CircularProgress />
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    marginTop: "82px",
                                    marginLeft: "45%",
                                  }}
                                >
                                  No Rows
                                </Box>
                              ),
                            NoResultsOverlay: () => (
                              <Box
                                sx={{
                                  position: "absolute",
                                  marginTop: "82px",
                                  marginLeft: "45%",
                                }}
                              >
                                No Results Found
                              </Box>
                            ),
                          }}
                        />
                      </Box>
                    </Box>
                  </Modal>

                  <Modal
                    open={openTeamModal}
                    onClose={handleModalCloseTeam}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          color="primary"
                          className="header-title"
                        >
                          Team Name:{" "}
                          <span style={{ color: "#c8102e" }}>{teamName}</span>
                        </Typography>
                        <IconButton
                          size="small"
                          aria-label="Close"
                          onClick={handleModalCloseTeam}
                          title="Close"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Box>
                      <Box
                        sx={{
                          height: "91%",
                          marginTop: theme.spacing(0.7),
                        }}
                      >
                        <DataGrid
                          className={classes.gridRoot}
                          pageSize={votedTeamPlayerGridDetails.length}
                          rowHeight={38}
                          headerHeight={35}
                          hideFooterPagination={true}
                          autoHeight={false}
                          rows={votedTeamPlayerGridDetails}
                          columnBuffer={
                            ["03", "05"].includes(eventIdval) ? 3 : 7
                          }
                          columns={
                            ["03", "05"].includes(eventIdval)
                              ? [
                                  { field: "id", hide: true, flex: 1 },
                                  {
                                    field: "playerName",
                                    headerName: "Player Name",
                                    width: 180,
                                    flex: columnFlex,
                                    sortable: false,
                                  },
                                  {
                                    field: "collegeOrClub",
                                    headerName: "College/Club",
                                    width: 180,
                                    flex: columnFlex,
                                    sortable: false,
                                  },
                                  {
                                    field: "isVoted",
                                    headerName: "Is Voted",
                                    width: 200,
                                    flex: columnFlex,
                                    sortable: false,
                                    renderCell: () => {
                                      return (
                                        <DoneIcon
                                          className={classes.GridIcon}
                                        />
                                      );
                                    },
                                  },
                                ]
                              : [
                                  { field: "id", hide: true, flex: 1 },
                                  {
                                    field: "playerName",
                                    headerName: "Player Name",
                                    width: 180,
                                    flex: columnFlex,
                                    sortable: false,
                                  },
                                  {
                                    field: "collegeOrClub",
                                    headerName: "College/Club",
                                    width: 180,
                                    flex: columnFlex,
                                    sortable: false,
                                  },
                                  {
                                    field: "pointGuard",
                                    headerName: isSmallScreen
                                      ? "PG"
                                      : "Point Guard",
                                    width: isSmallScreen ? 30 : 200,
                                    flex: columnFlex,
                                    sortable: false,
                                    renderCell: (params) => {
                                      if (params.formattedValue === 1) {
                                        return (
                                          <DoneIcon
                                            className={classes.GridIcon}
                                          />
                                        );
                                      } else {
                                        return "";
                                      }
                                    },
                                  },
                                  {
                                    field: "shootingGuard",
                                    headerName: isSmallScreen
                                      ? "SG"
                                      : "Shooting Guard",
                                    width: isSmallScreen ? 30 : 200,
                                    flex: columnFlex,
                                    sortable: false,
                                    renderCell: (params) => {
                                      if (params.formattedValue === 1) {
                                        return (
                                          <DoneIcon
                                            className={classes.GridIcon}
                                          />
                                        );
                                      } else {
                                        return "";
                                      }
                                    },
                                  },
                                  {
                                    field: "smallForward",
                                    headerName: isSmallScreen
                                      ? "SF"
                                      : "Small Forward",
                                    width: isSmallScreen ? 30 : 200,
                                    flex: columnFlex,
                                    sortable: false,
                                    renderCell: (params) => {
                                      if (params.formattedValue === 1) {
                                        return (
                                          <DoneIcon
                                            className={classes.GridIcon}
                                          />
                                        );
                                      } else {
                                        return "";
                                      }
                                    },
                                  },
                                  {
                                    field: "powerForward",
                                    headerName: isSmallScreen
                                      ? "PF"
                                      : "Power Forward",
                                    width: isSmallScreen ? 30 : 200,
                                    flex: columnFlex,
                                    sortable: false,
                                    renderCell: (params) => {
                                      if (params.formattedValue === 1) {
                                        return (
                                          <DoneIcon
                                            className={classes.GridIcon}
                                          />
                                        );
                                      } else {
                                        return "";
                                      }
                                    },
                                  },
                                  {
                                    field: "center",
                                    headerName: isSmallScreen ? "C" : "Center",
                                    width: isSmallScreen ? 30 : 200,
                                    flex: columnFlex,
                                    sortable: false,
                                    renderCell: (params) => {
                                      if (params.formattedValue === 1) {
                                        return (
                                          <DoneIcon
                                            className={classes.GridIcon}
                                          />
                                        );
                                      } else {
                                        return "";
                                      }
                                    },
                                  },
                                ]
                          }
                          disableSelectionOnClick
                          disableColumnSelector
                          getCellClassName={(params) => {
                            if (params.field !== "actions") {
                              return `admin-pref-grid-cells`;
                            }
                          }}
                          components={{
                            NoRowsOverlay: () =>
                              modalLoading ? (
                                <Box
                                  sx={{ marginTop: "15vh", marginLeft: "50%" }}
                                >
                                  <CircularProgress />
                                </Box>
                              ) : (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    marginTop: "82px",
                                    marginLeft: "45%",
                                  }}
                                >
                                  No Rows
                                </Box>
                              ),
                            NoResultsOverlay: () => (
                              <Box
                                sx={{
                                  position: "absolute",
                                  marginTop: "82px",
                                  marginLeft: "45%",
                                }}
                              >
                                No Results Found
                              </Box>
                            ),
                          }}
                        />
                      </Box>
                    </Box>
                  </Modal>
                </SwipeableViews>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
